<div class="container-fluid my-2 px-0">
  <!-- Search Field -->
  <div class="search-section">
    <mat-form-field appearance="outline" class="search-field">
      <mat-label>{{ 'TRANSACTION.SEARCH.LABEL' | transloco }}</mat-label>
      <input matInput (keyup)="applyFilter($event)"
        [placeholder]="'TRANSACTION.SEARCH.PLACEHOLDER' | transloco" #input>
      <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>
  </div>

  <!-- Collapsible Filters -->
  <div class="filters-container">
    <div class="filters-header" (click)="toggleFilters()">
      <div class="filters-title">
        <mat-icon>filter_list</mat-icon>
        <span>{{ 'TRANSACTION.FILTER.TITLE' | transloco }}</span>
      </div>
      <mat-icon class="expand-icon" [class.expanded]="filtersExpanded">expand_more</mat-icon>
    </div>

    <div class="filters-content" [class.expanded]="filtersExpanded">
      <form [formGroup]="transactionForm">
        <div class="filters-grid">

          <!-- Date Range -->
          <div class="filter-group">
            <mat-form-field appearance="outline">
              <mat-label>{{ 'TRANSACTION.FILTER.TRANSACTION_DATE' | transloco }}</mat-label>
              <mat-date-range-input [formGroup]="transactionForm" [rangePicker]="dateRangePicker">
                <input matStartDate formControlName="dateFrom" [placeholder]="'TRANSACTION.FILTER.DATE_FROM' | transloco">
                <input matEndDate formControlName="dateTo" [placeholder]="'TRANSACTION.FILTER.DATE_TO' | transloco">
              </mat-date-range-input>
              <mat-datepicker-toggle matSuffix [for]="dateRangePicker"></mat-datepicker-toggle>
              <mat-date-range-picker #dateRangePicker></mat-date-range-picker>
            </mat-form-field>
          </div>

          <!-- Payment Status Multi-Select -->
          <div class="filter-group multiple-select">
            <mat-form-field>
              <mat-select [placeholder]="'TRANSACTION.FILTER.PAYMENT_STATUS' | transloco" formControlName="paymentStatusFilter" multiple>
                @for (status of availablePaymentStatuses; track status) {
                  <mat-option [value]="status">
                    {{ status }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>

          <!-- Payment Type Multi-Select -->
          <div class="filter-group multiple-select">
            <mat-form-field>
              <mat-select [placeholder]="'TRANSACTION.FILTER.PAYMENT_TYPE' | transloco" formControlName="paymentTypeFilter" multiple>
                @for (type of availablePaymentTypes; track type) {
                  <mat-option [value]="type">
                    {{ type }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>

          <!-- Filter Actions -->
          <div class="filter-actions">
            <button mat-fab color="primary" [attr.aria-label]="'TRANSACTION.FILTER.UPDATE' | transloco" (click)="getTransactions()"
              [matTooltip]="'TRANSACTION.FILTER.UPDATE' | transloco">
              <mat-icon>refresh</mat-icon>
            </button>
            <button mat-stroked-button color="primary" (click)="clearFilters()">
              <mat-icon>clear</mat-icon>
              {{ 'TRANSACTION.FILTER.CLEAR' | transloco }}
            </button>
          </div>

        </div>
      </form>
    </div>
  </div>

  <!-- Results -->
  <div class="results-section">
    <mat-paginator [pageSizeOptions]="[100, 150, 250]" showFirstLastButtons></mat-paginator>
    <div class="overflow-auto">
      <table mat-table matSort [dataSource]="dataSource" class="results-table mat-elevation-z2">

        <ng-container matColumnDef="orderNr">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'TRANSACTION.TABLE.ORDER_NUMBER' | transloco }}</th>
          <td mat-cell *matCellDef="let transaction"> {{ transaction.orderNr }} </td>
        </ng-container>

        <ng-container matColumnDef="transactionNr">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'TRANSACTION.TABLE.TRANSACTION_NUMBER' | transloco }}</th>
          <td mat-cell *matCellDef="let transaction"> {{ transaction.transactionNr }} </td>
        </ng-container>

        <ng-container matColumnDef="amount">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'TRANSACTION.TABLE.AMOUNT' | transloco }}</th>
          <td mat-cell *matCellDef="let transaction"> {{ transaction.amount }} </td>
        </ng-container>

        <ng-container matColumnDef="vatAmount">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'TRANSACTION.TABLE.VAT_AMOUNT' | transloco }}</th>
          <td mat-cell *matCellDef="let transaction"> {{ transaction.vatAmount }}</td>
        </ng-container>

        <ng-container matColumnDef="amountIncVat">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'TRANSACTION.TABLE.AMOUNT_INC_VAT' | transloco }}</th>
          <td mat-cell *matCellDef="let transaction"> {{ transaction.amountIncVat }}</td>
        </ng-container>

        <ng-container matColumnDef="paymentStatus">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'TRANSACTION.TABLE.PAYMENT_STATUS' | transloco }}</th>
          <td mat-cell *matCellDef="let transaction"> {{ transaction.paymentStatus }}</td>
        </ng-container>

        <ng-container matColumnDef="paymentType">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'TRANSACTION.TABLE.PAYMENT_TYPE' | transloco }}</th>
          <td mat-cell *matCellDef="let transaction"> {{ transaction.paymentType }}</td>
        </ng-container>

        <ng-container matColumnDef="paymentDate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'TRANSACTION.TABLE.PAYMENT_DATE' | transloco }}</th>
          <td mat-cell *matCellDef="let transaction"> {{ transaction.paymentDate | date: 'yyyy-MM-dd HH:mm' }}</td>
        </ng-container>

        <ng-container matColumnDef="debitCreditType">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'TRANSACTION.TABLE.CHARGE_TYPE' | transloco }}</th>
          <td mat-cell *matCellDef="let transaction"> {{ transaction.debitCreditType }}</td>
        </ng-container>

        <ng-container matColumnDef="created">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'TRANSACTION.TABLE.CREATED' | transloco }}</th>
          <td mat-cell *matCellDef="let transaction"> {{ transaction.created | date: 'yyyy-MM-dd HH:mm' }}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let transaction; columns: displayedColumns;"
          (click)="goToOrder(transaction.orderId)" class="clickable-row">
        </tr>

        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell no-data" [attr.colspan]="displayedColumns.length">
            <div class="no-data-content">
              <mat-icon>search_off</mat-icon>
              <span>{{ 'TRANSACTION.TABLE.NO_MATCHES' | transloco }} "{{ input.value }}"</span>
            </div>
          </td>
        </tr>

      </table>
    </div>
  </div>
</div>
